'use strict';

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

module.exports = require('./en-US');


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/en.js
// module id = 197
// module chunks = 0